module.exports = __webpack_public_path__ + "static/one-no-poverty.037769a0.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/2022/photos/a-propos/sdgs/one-no-poverty.png
// module id = 920
// module chunks = 3